import { Modal, Checkbox, Button, Spin, Divider } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { useEffect, useState } from 'react';

interface CategoryRoleModalProps {
    open: boolean;
    user: any;
    categories: any[];
    loading: boolean;
    initialChecked: number[];
    onClose: () => void;
    onSave: (userId: number, checkedCategoryIds: number[]) => void;
}

const CategoryRoleModal = ({ open, user, categories, loading, initialChecked, onClose, onSave }: CategoryRoleModalProps) => {
    const [checkedList, setCheckedList] = useState<number[]>([]);

    const handleChange = (checkedValues: any[]) => {
        setCheckedList(checkedValues);
    };

    const handleCheckAllChange = (e: CheckboxChangeEvent) => {
        setCheckedList(e.target.checked ? categories.map(c => c.id) : []);
    };

    const handleSave = () => {
        if (user) {
            onSave(user.userId, checkedList);
        }
    };

    const isAllChecked = categories.length > 0 && checkedList.length === categories.length;
    const isIndeterminate = checkedList.length > 0 && checkedList.length < categories.length;

    useEffect(() => {
        if (open) {
            setCheckedList(initialChecked || []);
        }
    }, [open, initialChecked]);

    return (
        <Modal
            title={`카테고리 권한 관리 - ${user?.name || ''}`}
            open={open}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>취소</Button>,
                <Button key="submit" type="primary" onClick={handleSave}>
                    적용
                </Button>,
            ]}
            width={400}
            centered
        >
            {loading ? (
                <div style={{ textAlign: 'center', padding: '20px' }}><Spin /></div>
            ) : categories.length === 0 ? (
                <p>카테고리가 존재하지 않습니다.</p>
            ) : (
                <>
                    <Checkbox
                        indeterminate={isIndeterminate}
                        onChange={handleCheckAllChange}
                        checked={isAllChecked}
                    >
                        전체 선택
                    </Checkbox>
                    <Divider style={{ margin: '12px 0' }} />
                    <Checkbox.Group 
                        style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '8px' }}
                        value={checkedList}
                        onChange={handleChange}
                    >
                        {categories.map(category => (
                            <Checkbox key={category.id} value={category.id}>
                                {category.name}
                            </Checkbox>
                        ))}
                    </Checkbox.Group>
                </>
            )}
        </Modal>
    );
};

export default CategoryRoleModal;